import type { AnalysisType } from 'config/analysisConfig';

export type EditModeReturnState = {
  seriesId: string;
  analysisType: AnalysisType;
  layoutType: string;
  segmentManagerWasActive: boolean;
};

let editModeReturnState: EditModeReturnState | null = null;

export function saveEditModeReturnState(state: EditModeReturnState) {
  editModeReturnState = state;
}

export function getEditModeReturnState() {
  return editModeReturnState;
}

export function clearEditModeReturnState() {
  editModeReturnState = null;
}
